import { ElementType } from 'react';
import { Description } from '@mui/icons-material';
import {
  BadgeHelp,
  Files,
  GanttChartSquare,
  PieChart,
  Stethoscope,
} from 'lucide-react';

export type DashboardNavItem = {
  id: string;
  name: string;
  Icon: ElementType;
  path: string;
  placement: 'primary' | 'footer';
};

const dashboardSections: DashboardNavItem[] = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    Icon: PieChart,
    path: '/',
    placement: 'primary',
  },
  {
    id: 'projects',
    name: 'Projects',
    Icon: GanttChartSquare,
    path: '/projects',
    placement: 'primary',
  },
  {
    id: 'files',
    name: 'Files',
    Icon: Files,
    path: '/files',
    placement: 'primary',
  },
  {
    id: 'patients',
    name: 'Patients',
    Icon: Stethoscope,
    path: '/patients',
    placement: 'primary',
  },
  {
    id: 'samples',
    name: 'Samples',
    Icon: Description,
    path: '/samples',
    placement: 'primary',
  },
  {
    id: 'help',
    name: 'Help',
    Icon: BadgeHelp,
    path: '/help',
    placement: 'footer',
  },
];

export default dashboardSections;
